<template>
  <div class="content">
    <el-table :data="tableData" border>
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="title" label="业务标题" align="center"></el-table-column>
      <el-table-column prop="processInstanceId" label="流程编号" align="center"></el-table-column>
      <el-table-column prop="processDefinitionName" label="流程名称" align="center"></el-table-column>
      <el-table-column prop="startUserName" label="发起人" align="center"></el-table-column>
      <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
      <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center"></el-table-column>
      <el-table-column prop="durationTime" label="耗时" align="center"></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-s-unfold" @click="info(scope.row.processInstanceId)">历史</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { historicActivityPerson } from "@/api/api.js"; //流程实例分页查询
export default {
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      }
      historicActivityPerson(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
          })
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 历史
    info(id){
      this.$router.push( `/procedure/history/`+id);
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  created() {

  }
};
</script>
<style scoped lang="less">

</style>


